import { AncillaryManagerListItem } from "../../../integrated-client/models";

interface ITableData {
  records: Array<AncillaryManagerListItem>;
}

export class TableData implements ITableData {
  records: Array<AncillaryManagerListItem>;

  constructor() {
    this.records = [];
  }
}
